<template>
  <RF-Dialog
    :cpntLargura='"600px"'
    :cpntStatus="statusGeral"
    :cpntTitulo="'Realizar ciência da operação'"
    :cpntOnFecharDialog='dfRecebidosDialogFechar'>
    <template slot="conteudo">
      <div class="df-recebidos-ciencia">
        <div class="dados">
          <!-- <b>Atenção !!</b>
          <br/>
          <br/>
          Abaixo você poderá se manifestar, referente aos dados desta NF-e emitida contra seu CNPJ.
          <br/>
          <br/>
          
          <table>
            <tr>
              <td class="nome">
                <div>Emitente</div>
                <span v-html="cpntDados.xNome"></span>
              </td>
              <td class="cnpj">
                <div>CNPJ</div>
                <span v-html="cpntDados.CNPJ"></span>
              </td>
              <td class="ie">
                <div>IE</div>
                <span v-html="cpntDados.IE"></span>
              </td>
            </tr>
          </table>
          <table class="dividido-4">
            <tr>
              <td>
                <div>Operação</div>
                <span>{{ cpntDados.tpNF }} - {{ cpntDados.tpNF === '0' ? 'Entrada' : 'Saída' }}</span>
              </td>
              <td>
                <div>Número</div>
                <span>{{ cpntDados.nNF }}</span>
              </td>
              <td>
                <div>Série</div>
                <span>{{ cpntDados.serie }}</span>
              </td>
              <td>
                <div>Valor</div>
                <span>R$ {{ cpntDados.vNF }}</span>
              </td>
            </tr>
          </table>
          <table class="final">
            <tr>
              <td>
                <div>Chave de acesso</div>
                <span>{{ cpntDados.chNFe }}</span>
              </td>
            </tr>
          </table> -->

          <br/>
          <b>Importante!</b> Está operação não poderá ser desfeita.
          <br/>
          <br/>

          <div>
            <!-- SETA O CAMPO PARA SELEÇÃO -->
            <App-Select :data-time="time" class="app-cpnt-field"
              :cpntStatus='campos.evento.status'
              :cpntId='campos.evento.id'
              :cpntTabIndex='campos.evento.tabIndex'
              :cpntNome='campos.evento.nome'
              :cpntValue='campos.evento.value'
              :cpntMensagem='campos.evento.mensagem'
              :cpntMensagemTipo='campos.evento.mensagemTipo'
              :cpntDisabled='campos.evento.disabled'
              :cpntMostrar='campos.evento.mostrar'
              :cpntExplica='campos.evento.explica'
              :cpntPlaceholder='campos.evento.placeholder'
              :cpntValueRef='campos.evento.valueRef'
              :cpntRouter='campos.evento.router'
              :cpntMethod='campos.evento.method'
              :cpntField='campos.evento.field'
              :cpntWhere='campos.evento.where'
              :cpntAddButForm='campos.evento.addButForm'
              :cpntKeyMostra='campos.evento.keyMostra'
              :cpntTipoOrder='campos.evento.tipoOrder'
              :cpntOrder='campos.evento.order'
              :cpntOptions='campos.evento.options'
              :cpntKeyValue='campos.evento.keyValue'
              :cpntSearchMinimo='campos.evento.searchMinimo'
              :cpntMask='campos.evento.mask'
              :cpntOptionInicialNome='campos.evento.optionInicialNome'
              :cpntOptionInicialValue='campos.evento.optionInicialValue'

              :cpntOnBuscarOptions='campos.evento.onBuscarOptions'
              :cpntOnChange='campos.evento.onChange'
              :cpntOnBlur='campos.evento.onBlur'
              :cpntOnRealizaBusca='campos.evento.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.evento.onKeyPressEnter'
              ref="evento"
            ></App-Select>

            <!-- SETA O BOTÃO ENVIAR -->
            <RF-Button style="margin-top: 16px;"
              :cpntId='campos.enviar.id'
              :cpntStatus='campos.enviar.status' 
              :cpntTipo='campos.enviar.tipo'
              :cpntTexto='campos.enviar.texto'
              :cpntIcone='campos.enviar.icone'
              :cpntClass='campos.enviar.class'
              @onClickButton='() => { campos.enviar.onClick() }'
            ></RF-Button>
          </div>
        </div>
        
        <!-- teste ({{ cpntDados }})  -->
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .df-recebidos-ciencia > .dados {
    text-align: center;
  }
  .df-recebidos-ciencia > .dados > b {
    font-style: italic;
    font-size: calc(100% + 1px);
  }

  .df-recebidos-ciencia > .dados > table {
    width: 100%;
    margin-top: 3px;
    border-collapse: separate;
  }
      .df-recebidos-ciencia > .dados > table > tr > td {
        background: #f4f4f4;
        border: 1px solid #ccc;
        padding: 4px;
        vertical-align: middle;
      }
      .df-recebidos-ciencia > .dados > table > tr > td:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      .df-recebidos-ciencia > .dados > table > tr > td:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      .df-recebidos-ciencia > .dados > table:not(.final) > tr > td:first-child {
        border-right: none;
      }
      .df-recebidos-ciencia > .dados > table:not(.final) > tr > td:last-child {
        border-left: none;
      }
        .df-recebidos-ciencia > .dados > table > tr > td > div {
          font-weight: bold;
        }

      .df-recebidos-ciencia > .dados > table > tr > td.cnpj {
        width: 150px;
      }
      .df-recebidos-ciencia > .dados > table > tr > td.ie {
        width: 120px;
      }

      .df-recebidos-ciencia > .dados > table.dividido-4 > tr > td {
        width: calc(100% / 4);
      }

  .df-recebidos-ciencia > .dados > div > .app-cpnt-field {
    width: 300px;
    margin-top: 20px !important;
    margin-bottom: 10px !important;
    text-align: left;
  }
  .df-recebidos-ciencia > .dados > div > .app-cpnt-field ~ button {
    margin-left: 10px;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDados: {
        type: Number,
        required: true
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        campos: {
          evento: {
            id: this.cpntHashId + '--evento',
            status: '',
            nome: 'Evento',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [
              { id: '210210', nome: 'Ciencia da operação' },
              // { id: '210200', nome: 'Confirmação da operação' },
              // { id: '210220', nome: 'Desconhecimento da operação' },
              // { id: '210240', nome: 'Operação nao realizada' }
            ],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            apiEnv: 'tp_evento',
            onChange: this.dfRecebidosDialogOnChangeValue
          },
          enviar: {
            status: '',
            tipo: 'texto',
            texto: 'Enviar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: this.dfRecebidosDialogSalvar
          },
        }
      }
    },
    mounted: function () {
    },
    methods: {
      dfRecebidosDialogSetarStatusGeral: function (status = '') {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      dfRecebidosDialogFechar: function (atualizar = false) {
        this.cpntFecharFormulario(atualizar === true)
      },
      dfRecebidosDialogSalvar: function () {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.campos.enviar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = () => { this.dfRecebidosDialogFechar(true) }

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
          // SETA O ID QUE ESTÁ SENDO MANIFESTADO
          formData.j_df = '[' + this.cpntDados.id + ']'
          
          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/df/distribuicao/manifesta', 'POST', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = retorno.lot[0]

            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.dfRecebidosDialogTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              finalizacao()
            }
          }, this.dfRecebidosDialogSetarStatusGeral, (apiValid, apiStatus) => { this.dfRecebidosDialogTratarValidacao(apiValid, apiStatus, finalizacao) })
        })
      },
      dfRecebidosDialogTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {          
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      dfRecebidosDialogOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
    }
  }
</script>
